import axios from 'utils/axios';

const AbstractSubmissionCreateService = async (data) => {
    return await axios.post('api/prv/member_abstracts', data);
};

export default AbstractSubmissionCreateService;
